import { StripeCurrency } from '../types/stripe';

export const PUBLIC_KEY =
  process.env.REACT_APP_STRIPE_PUBLIC_KEY || 'undefined_key';

export const CURRENCY: StripeCurrency = (process.env
  .REACT_APP_STRIPE_DEFAULT_CURRENCY || 'es-ES') as StripeCurrency;
